import React, { Component } from 'react'
import IconButton from '@material-ui/core/IconButton';
import PlayIcon from '@material-ui/icons/PlayCircleFilled';
import StopIcon from '@material-ui/icons/Stop';
//import { SpeakText } from './Speak'
//import { LoadSpeak } from './Speak'
import TextField from '@material-ui/core/TextField';
import Gamepad from './Gamepad'

import SettingsDialog from './SettingsDialog'


let mar =true;
let G_timer;


var spa_found = false;
var G_spanish_voice = "";

function GerSpanishVoice(){
  var voices = speechSynthesis.getVoices();      
    voices.forEach(function(voice, i) {
    if(voice.name.toLowerCase().indexOf("mex") != -1)
    {
      G_spanish_voice = voice.name;
      spa_found=true;
    }
    else if(voice.name.toLowerCase().indexOf("span") != -1 && !spa_found)
    {
      G_spanish_voice = voice.name;
    }
//    alert(voice.name);
    });

   var hiddenVoice = document.getElementById('hidden_voice');
   hiddenVoice.innerHTML = G_spanish_voice;
   //alert(G_spanish_voice);
}





export class Play extends Component {

    state = {
        playON:false,
        currentWordId:0,
        Verzug:3,
        Language1: true,
        Language2: false,
        Language3: false,
        Description1: false,
        Description2: false,
        Description3:false
     }


        onPlayclick=()=>{
            var newplayON=true
            if(this.state.playON)
            {newplayON=false}
            
            this.setState({
                playON:newplayON
            });
            if(newplayON)
            {
                this.SpeakText(this.props.words[0].Language1);
            }
            else
            {
                speechSynthesis.cancel();
            }

        }

        process_next_word=(ascending)=>{
            clearInterval(G_timer);
            let id;
            let word_to_speak = "";
            if(ascending)
            {
                 id = this.state.currentWordId +1;
                 if(id>=this.props.words.length)
                 {
                    id=0;
                 }
            }
            else
            {
                id = this.state.currentWordId -1;
                if(id<0)
                {
                    id=this.props.words.length-1
                }
            }

            if(id<this.props.words.length)
            {
                // alert("less");
                // if(this.props.words[id].Language1!="")
                // {
                //     this.SpeakText(this.props.words[id].Language1);
                // }
                this.setState({
                    currentWordId:id
                })

                word_to_speak = this.GetRightWord(id);
                if(word_to_speak!="")
                {
                    this.SpeakText(word_to_speak);
                }
                else{
                    this.process_next_word(ascending);
                }
 
            }
            // else
            // {
            // // alert("more");
            //     this.setState({
            //         playON:false
            //     });
            // }

        }


 GetRightWord(id){
    let word_to_speak = "";
    if(this.state.Language1)
    {
        word_to_speak = this.props.words[id].Language1;
    }
    else if(this.state.Language2)
    {
        word_to_speak = this.props.words[id].Language2;
    }
    else if(this.state.Language3)
    {
        word_to_speak = this.props.words[id].Language3;
    }
    else if(this.state.Description1)
    {
        word_to_speak = this.props.words[id].Description1;
    }
    else if(this.state.Description2)
    {
        word_to_speak = this.props.words[id].Description2;
    }
    else if(this.state.Description3)
    {
        
    }
    return word_to_speak;
}


        SpeakText(text) {

        //   speechSynthesis.cancel();
            var msg = new SpeechSynthesisUtterance();
            var voices = window.speechSynthesis.getVoices();
            var Play = this;


            // var voiceSelect = document.getElementById('voice');
            // if (voiceSelect.value) {
            //     msg.voice = speechSynthesis.getVoices().filter(function(voice) { return voice.name == voiceSelect.value; })[0];
            // }
            if (G_spanish_voice!="") {
                msg.voice = speechSynthesis.getVoices().filter(function(voice) { return voice.name == G_spanish_voice; })[0];
            }

            msg.text = text;
           // console.log(this);
            msg.onend = function (e) {
                if(Play.state.playON)
                {
                //    console.log(this);
                    G_timer = setInterval(()=>Play.process_next_word(true), Play.state.Verzug * 1000);
                }
            };
        
            speechSynthesis.speak(msg);

        }





        handleChange=(e)=>{
            this.setState({
                [e.target.id]: e.target.value
            })
        }

        GamepadPressed= (g_command) =>{
       
            speechSynthesis.cancel();
            if(g_command=="right")
            {
                this.process_next_word(true)
            }
            if(g_command=="left")
            {
                this.process_next_word(false)
            }
            if(g_command=="up")
            {

                if(this.props.words[this.state.currentWordId].Language2 != "")
                {
                    this.SpeakText(this.props.words[this.state.currentWordId].Language2);
                }
                else if(this.props.words[this.state.currentWordId].Language3 != "")
                {
                    this.SpeakText(this.props.words[this.state.currentWordId].Language3);
                }
            //    var msg = new SpeechSynthesisUtterance();
            //    msg.text = this.props.words[this.state.currentWordId].Language2;
            //     speechSynthesis.speak(msg);
                //console.log("up");
            }
            if(g_command=="down")
            {
                this.SpeakText(this.props.words[this.state.currentWordId].Language1);
            }
            if(g_command=="X")
            {
                if(this.props.words[this.state.currentWordId].Description1 != "")
                {
                    this.SpeakText(this.props.words[this.state.currentWordId].Description1);
                }
           //     alert("x");
                //this.SpeakText(this.props.words[this.state.currentWordId].Description1);
            }
            if(g_command=="Y")
            {
        //       alert("y");
                if(this.props.words[this.state.currentWordId].Description1 != "")
                {
                    this.SpeakText(this.props.words[this.state.currentWordId].Description1);
                }
   //     
             //   this.SpeakText(this.props.words[this.state.currentWordId].Description1);
            }
        }
           

        handleSettingsChanged=(Language1,Language2,Language3,Description1,Description2,Description3)=> {
            //alert("ds");
       //     this.props.handleSettingsChanged(Language1,Language2,Language3,Description1,Description2,Description3);
            this.setState({
                Language1: Language1,
                Language2: Language2,
                Language3: Language3,
                Description1: Description1,
                Description2: Description2,
                Description3:Description3
            })

    }


    componentDidMount() {
        GerSpanishVoice();
        }

    render() {
      
        return (
            <div>
                <Gamepad GamepadPressed={this.GamepadPressed}></Gamepad>


            {/* <div className="input-field col s12">
            <select name="voice" id="voice">
            </select>

            </div> */}

            <IconButton  onClick={()=>this.onPlayclick()} aria-label="Edit">
                {
                    this.state.playON?(<StopIcon />):(<PlayIcon />)
                }
              
            </IconButton>

            <SettingsDialog handleSettingsChanged={this.handleSettingsChanged}></SettingsDialog>
            <TextField fullWidth 
                        id="Verzug"
                        label="Verzug"
                        className="Verzug"
                        value={this.state.Verzug}
                        onChange={this.handleChange}
                        margin="normal"
                        max-width="100px"
                        />
                <div id="hidden_voice" ></div>  
                {
                  //  GerSpanishVoice()
                }    
            </div>

        )
  
    }
}

export default Play
